import Vue from "vue";
import { Component } from "vue-property-decorator";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { ContratAutoFromDsnDto } from "../../../dto/GenApi.iNotPaie.Dto/ContratAutoFromDsnDto";
import { ImportDsnAutoDto } from "../../../dto/GenApi.iNotPaie.Dto/ImportDsnAutoDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalDsn extends Vue {
	public dataReady = false;
	public ImportDsn?: ImportDsnAutoDto;

	public demande: ContratAutoFromDsnDto = {
    	CodeSociete: "",
    	File: ""
	}

	public init(): void {
    	if (ParametresInstance.utilisateurCourant == undefined) {
			return;
		}

    	this.demande = {
    		CodeSociete: "",
    		File: ""
    	};

    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
			this.demande.CodeSociete = ParametresInstance.societeCourante.Code;
		}

    	$("#modalDsn").modal("show");
	}

	public PutDsn(): void {
    	if (this.demande.File == undefined || this.demande.File == "") {
    		NotificationServiceInstance.SendFailed("Aucun fichier à lire.");

    		return;
    	}

    	ServicesFactoryInstance.ContratAutoFromDsnService.PutFichierDsn(this.demande, data => {
    		this.$emit("contratsCrees", data);
    	});
    	$("#modalDsn").modal("hide");
	}

	public annuler(): void {
    	this.demande.File = "";
    	this.demande.CodeSociete = "";
    	$("#modalDsn").modal("hide");
	}

	public changeFile(event: any): void {
    	this.init();
    	const someData = event.target.files[0]; // Je récupère le contenu de mon <input>
    	const reader = new FileReader(); // Je crée mon objet reader
    	const _this = this; // Permets d'accéder au this général même dans une fonction ?

    	reader.onloadend = function() { // Quand le reader à finis de lire
    		const src = reader.result; // On récupère son contenu
    		_this.updateSrc(src);
    	};

    	if (someData) {
    		reader.readAsText(someData, "ISO-8859-1");
    	}
	}

	public updateSrc(data: any): void {
    	this.demande.File = data.toString();
	}
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalDsn/modalDsn.ts